"use strict";
/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentLocked = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var iconTypes_1 = require("../../iconTypes");
var svgIconContainer_1 = require("../../svgIconContainer");
exports.DocumentLocked = React.forwardRef(function (props, ref) {
    var isLarge = props.size >= iconTypes_1.IconSize.LARGE;
    var pixelGridSize = isLarge ? iconTypes_1.IconSize.LARGE : iconTypes_1.IconSize.STANDARD;
    var translation = "".concat(-1 * pixelGridSize / 0.05 / 2);
    var style = { transformOrigin: "center" };
    return (React.createElement(svgIconContainer_1.SVGIconContainer, tslib_1.__assign({ iconName: "document-locked", ref: ref }, props),
        React.createElement("path", { d: isLarge ? "M60 400H220L340 280V208.892C328.264 215.8386 314.6 219.872 300 219.997V260H200V360H80V40H180V10C180 6.714 180.353 3.352 181.0498 0H60C49 0 40 9 40 20V380C40 391 49 400 60 400zM339.3 99.9L368.6 99.9C374.1 99.9 379.3 95.5 379.3 90V10C379.3 4.5 374.1 -0.1 368.6 -0.1H229.3C223.8 -0.1 220 4.5 220 10V90C220 95.5 223.8 99.9 229.3 99.9L259.3 99.9V140C259.3 162.1 277.2 180 299.3 180C321.4 180 339.3 162.1 339.3 140V99.9zM279.3 139.9V99.8H319.3V139.9C319.3 150.9 310.3 159.9 299.3 159.9C288.3 159.9 279.3 150.9 279.3 139.9z" : "M60 320H200L280 240V169.3486C268.19 176.134 254.502 180 240 180V220H180V280H80V40H140.002L140 11.9C140 7.83 140.4872 3.84 141.3868 0H60C49 0 40 9 40 20V300C40 311 49 320 60 320zM280.004 80H289.604C295.104 80 300.004 76.5 300.004 71L300 11.9C300 6.5 295.1 0 289.6 0H189.6C184.1 0 180 6.5 180 11.9L180.0044 71C180.0044 76.5 184.1044 80 189.6044 80H200.004V100.5C200.004 122.3 217.904 140 240.004 140C262.104 140 280.004 122.3 280.004 100.5V80zM220 100.3V80H260V100.3C260 111.2 251 120 240 120C229 120 220 111.2 220 100.3z", fillRule: "evenodd", transform: "scale(0.05, -0.05) translate(".concat(translation, ", ").concat(translation, ")"), style: style })));
});
exports.DocumentLocked.defaultProps = {
    size: iconTypes_1.IconSize.STANDARD,
};
exports.DocumentLocked.displayName = "Blueprint5.Icon.DocumentLocked";
exports.default = exports.DocumentLocked;
//# sourceMappingURL=document-locked.js.map